export { Dictionnary } from './dictionnary';